<script setup lang="ts">
import UIBanner from '@/components/ui/UIBanner.vue'
import { TBannerVariant } from '@lifk/types'
import { PhWarning } from '@phosphor-icons/vue'

defineProps<{
  /** What text should be displayed in the banner? */
  bannerText: string
  /** What variant of the banner should be used? */
  bannerVariant: TBannerVariant
}>()
</script>

<template>
  <UIBanner :variant="bannerVariant">
    <div class="flex items-center space-x-[10px]">
      <PhWarning
        v-if="bannerVariant == 'warning'"
        size="24"
        class="fill-charcoal shrink-0"
        weight="fill"
      />
      <p
        class="text-left pointer-events-auto"
        tabindex="0"
        role="status"
        :aria-label="bannerText"
      >
        {{ bannerText }}
      </p>
    </div>
  </UIBanner>
</template>
